import { Grid, useMediaQuery } from "@mui/material";
import styles from "./styles.module.css";

const CardView = ({ columns, data, textHeaderCard }) => {
  const minDesktop = useMediaQuery("(max-width: 495px)");
  const newData = data.map(({ botoes, ...rest }) => rest);
  const rows = data.length > 0 ? Object.keys(newData[0]) : "";

  const hasBotoes = data.some((item) => item.hasOwnProperty("botoes"));

  return (
    <div>
      <Grid container spacing={2} className={styles.container}>
        {data.map((item, index) => (
          <Grid
            item
            sm={12}
            lg={4}
            md={6}
            key={index}
            className={styles.grid_container}
          >
            <div className={styles.card_container}>
              <div className={styles.card_header}>{item[textHeaderCard]}</div>
              <div className={styles.card_content}>
                {rows.map((row, i) => (
                  <div
                    key={i}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <p className={styles.card_text}>
                      <strong>{columns[i]}:</strong> {item[row]}
                    </p>
                  </div>
                ))}
              </div>
              {hasBotoes ? (
                <div className={styles.card_buttons}>
                  {item.botoes.map((btn, n) => (
                    <button key={n} onClick={btn.onClick}>
                      <span>{btn.icon}</span>
                      {!minDesktop ? btn.title : ""}
                    </button>
                  ))}
                </div>
              ) : (
                ""
              )}
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CardView;
